var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InputMedia',{staticClass:"mt-5",attrs:{"id":_vm.id,"value":_vm.data,"server-files":_vm.library,"media-type":"hdrTexture"},on:{"change":_vm.changeMediaSource}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }